import React from 'react'
import {fichasData} from '../../../data/fichas.data';

interface Props{
    isFichaFullOpened: boolean,
    selectedBike: any
}

interface State{
    currentFicha: string
}

class FullFicha extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            currentFicha: ""
        }
    }

    componentDidUpdate(prevProps: any){
        if(prevProps.selectedBike !== this.props.selectedBike && this.props.selectedBike.Nombre){
            this.setState({
                currentFicha: fichasData()[0][this.props.selectedBike.Nombre].Ficha.default+"#view=FitH"
            }, () => {console.log(this.state.currentFicha)})
        }
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isFichaFullOpened ? "fichas-full fade-in":"fichas-full fade-out"}>
                <embed src={this.state.currentFicha} width="100%" height="100%" className="fichas-desktop" />
            </div>
        )
    }
}

export default FullFicha